export default (function stylesCookieGtmInitPlugin({ $cookieConsent, $gtm }) {
    $cookieConsent.onConsentChanged(() => {
        if ($cookieConsent.isCookieAllowed('targeting')) {
            $gtm.init();
        }
    });
});
